<div class="alert-box">
    <div class="alert-content">
        <img width="70" src="assets/images/warning.png"/>
        <br>
        <span style="font-size: 16x;"><strong>{{title}}</strong></span>
        
        <div class="tablecontent customScrollBar">
            {{message}}
        </div>
        
        <div class="col-md-12 text-center no-padding" >
            <button class="btn btn-blue-empty" value="cancel" (click)="Discard()">{{closeTitle}}</button>
            <button class="btn btn-blue" value="confirm" (click)="Process()" *ngIf="confirmTitle">{{confirmTitle}}</button>
        </div>


    </div>
</div>